import { t } from "i18next";

import { BookingClassesTabType } from "./types";

export const BOOKING_CLASSES_TABS: BookingClassesTabType[] = [
  {
    id: "upcoming",
    title: t("page.hostedPagesProfileBookingClasses.tabs.upcoming.title"),
  },
  {
    id: "past",
    title: t("page.hostedPagesProfileBookingClasses.tabs.past.title"),
  },
];
